<template lang="html">
	<div class="rs-footer">
		<div class="rs-logo-container">
			<small>powered by</small> <a 
				href="https://velocate.com" 
				rel="noopener" 
				target="_blank">
				<img 
					src="https://files.velocate.com/velocate-logo.png" 
					class="rs-logo" 
					alt="Velocate">
			</a>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Footer'
}
</script>

<style lang="css" scoped>
.rs-footer{
    margin: 3em 0;
}
.rs-logo-container{
    text-align: right;
}
.rs-logo{
    height: 20px;
}
</style>
